import { call, put, takeLatest } from 'redux-saga/effects';
import types from '../actions/fuentesabiertas.actions';
import { storeFuentesAbiertas } from '../actions/fuentesabiertas.actions';
import api from "../api/api";

export function* getFuentesAbiertas() {
    yield takeLatest(types.GET_FUENTES_ABIERTAS, takeLatestFuentesAbiertas);
}

function* takeLatestFuentesAbiertas() {
    const response = yield call(api.get, `/v1/fuentes-abiertas`);
    yield put(storeFuentesAbiertas(response.data.result));
}